export default {
  label: {
    title: 'Importar archivo',
    file: 'Archivo',
    insertFile: 'Seleccione el documento',
    cancel: 'Cancelar',
    ok: 'Ok',
    send: 'Enviar',
    clear: 'Limpiar',
    requiredValue: 'Valor obligatorio',
    processed: 'Planilha enviada con éxito',
    status: 'Estado: ',
    totalPosts: 'Total de Publicaciones: ',
    dataStorageUrl: 'Enlace de la planilla procesada: ',
    errorMessage: 'Descripción del error: ',
  },

  infoLabel: 'Información del formulario',
  closeLabel: 'Cerrar información',

  upload: {
    error: 'Hay errores en los posts de la planilla, verifique los datos e intente nuevamente.',
    success: 'Documento cargado con éxito',
  },

  faq: {
    title: '¿Cuál es el formato de la planilla?',
    description: 'La planilla debe estar en formato xlsx.',
  },
  faq2: {
    title: '¿Cuál es la formateación correcta de la planilla?',
    description: 'Este componente requiere una planilla en posesión de Stilingue, alojada en Google Sheets.',
  },
  faq3: {
    title: '¿Cómo saber si mis datos fueron importados?',
    description: 'El resultado de la importación será enviado por correo electrónico.',
  },
};
